export enum LookUpStrategy {
  Some = 'some',
  Every = 'every'
}
